import React, { useState } from "react";
import "./recommendations.css";
import SignupToolbar from "../../components/lawyerToolbar/signupToolbar";
import DeterminateProgress from "../../components/input/new/determinateProgress";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchAttorney, fetchToken, fetchVideoToken, fetchOnboardingStage } from "../../redux/attorneyDataSlice";
import { fetchFirmDetails } from "../../redux/firmSlice";

// Replace these with your actual images, placeholders, or remove if you prefer
// import sampleImage from '../assets/sampleImage.png';

export default function Recommendations() {
  // Example data for the recommended items
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { dataToPass } = location.state || {};
  const { data, goals } = dataToPass || {};
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  console.log(location.state);
  console.log("dataToPass:", dataToPass);
  console.log("data:", data);
  console.log("goals:", goals);

  const userId = data.user.id;
  console.log("userId:", userId);

  const toggleRecommendation = (id) => {
    if (selectedRecs.includes(id)) {
      setSelectedRecs(selectedRecs.filter((itemId) => itemId !== id));
    } else {
      setSelectedRecs([...selectedRecs, id]);
    }
  };

  const handleContinue = async () => {
    setIsLoading(true);
    setError(null);
    try {
      // First fetch attorney data to get the firm_id
      console.log("Fetching attorney data for userId:", userId);
      const attorneyResult = await dispatch(fetchAttorney(userId));
      const attorneyData = attorneyResult.payload;
      
      console.log("Attorney data result:", attorneyResult);
      console.log("Attorney data payload:", attorneyData);
      
      // Check if attorney data was fetched successfully
      if (!attorneyData || Object.keys(attorneyData).length === 0) {
        throw new Error("No attorney data received from API");
      }
      
      // If attorney data has a firm_id, fetch firm details
      if (attorneyData && attorneyData.firm_id) {
        console.log("Fetching firm details for firm_id:", attorneyData.firm_id);
        await dispatch(fetchFirmDetails(attorneyData.firm_id));
      }
      
      // Also fetch tokens and onboarding stage that are needed for the homepage
      console.log("Fetching additional data (tokens, onboarding stage)");
      await Promise.all([
        dispatch(fetchToken(userId)),
        dispatch(fetchVideoToken(userId)),
        dispatch(fetchOnboardingStage(userId))
      ]);
      
      console.log("All data fetched successfully, navigating to homepage");
      // Navigate to the attorney homepage
      navigate(`/attorney/${userId}/home`);
      console.log("Continue clicked.");
    } catch (error) {
      console.error("Error fetching attorney data:", error);
      setError(`Failed to load your account data: ${error.message}. Please try again.`);
      // Don't navigate if there's an error - let the user see the error and retry
      // navigate(`/attorney/${userId}/home`);
    } finally {
      setIsLoading(false);
    }
  };
  const recommendedItems = [
    {
      id: 1,
      title: "Quidpro Marketplace",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.",
      highlight: "NEW CLIENT BOOKING FEE",
      bold: "150$",
      linkText: "Learn more",
      type: "paid",

      //   image: sampleImage, // Replace with your actual image
    },
    {
      id: 2,
      title: "Book from Google",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
      linkText: "Learn more",
      image: null, // or a different image if you prefer
      type: "free",
    },
    {
      id: 3,
      title: "Online scheduling from your website",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
      linkText: "Learn more",
      image: null,
      type: "free",
    },
    {
      id: 4,
      title: "Intake",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
      linkText: "Learn more",
      image: null,
      type: "free",
    },
    {
      id: 5,
      title: "Video Service",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
      linkText: "Learn more",
      image: null,
      type: "free",
    },
  ];

  const initialSelectedRecs = recommendedItems.reduce((acc, item) => {
    if (item.type === "paid" || (goals && goals.includes(item.id))) {
      acc.push(item.id);
    }
    return acc;
  }, []);

  const [selectedRecs, setSelectedRecs] = useState(initialSelectedRecs);

  return (
    <div>
      <SignupToolbar onlyHelp={true} />
      <div className="recommendations-container">
        <div className="recommended-content">
          <h2 className="recommended-title">
            Here’s what we recommend to get started
          </h2>
          <p className="recommended-subtext">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>

          <div className="recommended-list">
            {recommendedItems.map((item) => {
              // Determine if this recommendation is selected by our algorithm
              const isSelected = selectedRecs.includes(item.id);

              return (
                <div className="recommended-card" key={item.id}>
                  <div className="card-left">
                    {item.image ? (
                      <img
                        src={item.image}
                        alt={item.title}
                        className="card-image"
                      />
                    ) : (
                      <div className="empty-image" />
                    )}
                  </div>
                  <div className="card-right">
                    <div className="rec-card-content">
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <h3 className="rec-card-title">{item.title}</h3>
                        {item.type === "paid" && (
                          <span className="type-badge paid-badge">Paid</span>
                        )}
                        {item.type === "free" && (
                          <span className="type-badge free-badge">Free</span>
                        )}
                      </div>
                      <p className="rec-card-description">{item.description}</p>
                      {item.highlight && item.bold && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                            gap: "5px",
                          }}
                        >
                          <span className="highlight-text">
                            {item.highlight}
                          </span>
                          <span className="highlight-bold">{item.bold}</span>
                        </div>
                      )}
                    </div>
                    <div className="card-link-container">
                      <a href="#0" className="learn-more-link">
                        {item.linkText}
                      </a>
                      <input
                        type="checkbox"
                        style={{ height: "20px", width: "20px" }}
                        checked={isSelected}
                        onChange={() => toggleRecommendation(item.id)}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <DeterminateProgress value={100} />
        
        {error && (
          <div className="error-message" style={{
            color: '#d32f2f',
            backgroundColor: '#ffebee',
            padding: '12px',
            margin: '16px 0',
            borderRadius: '4px',
            border: '1px solid #f44336',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}
        
        <div className="bottom-bar">
          <div className="bottom-bar-left">
            <span className="section-label">Log in</span>
            <span className="step-indicator">Step 5 of 5</span>
          </div>
          <button
            type="button"
            className="continue-btn-recommend"
            onClick={handleContinue}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Go to my account"}
          </button>
        </div>
      </div>
    </div>
  );
}
